module.exports = __webpack_public_path__ + "static/ARB_PHOTOGRAPHY_6-13a4771cc7c1070a19216d0cc7ce8533.jpg";